// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"style_cardContainer__CviVM","imagesContainer":"style_imagesContainer__3kjoY","cardImg":"style_cardImg__2UCzd"};